import React from 'react';
import {Tab} from "semantic-ui-react";
import SupplierInvoiceSummary from "./supplier-invoice-summary";
import SupplierInvoiceDetails from "./supplier-invoice-details";
import SupplierMeterDetails from "./supplier-meter-details";

class SupplierDetailsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    panes = [
        { menuItem: 'Supplier Invoice Summary', render: () => <Tab.Pane><SupplierInvoiceSummary supplierInvoiceKey={this.props.supplierInvoiceKey} customerId={this.props.customerId}/></Tab.Pane> },
        { menuItem: 'Supplier Invoice Details', render: () => <Tab.Pane><SupplierInvoiceDetails supplierInvoiceKey={this.props.supplierInvoiceKey} /></Tab.Pane> },
        { menuItem: 'Supplier Meter Read', render: () => <Tab.Pane><SupplierMeterDetails supplierInvoiceKey={this.props.supplierInvoiceKey} /></Tab.Pane> },
        // { menuItem: 'Exceptions', render: () => <Tab.Pane><SupplierExceptionsDetails supplierInvoiceKey={this.props.supplierInvoiceKey} /></Tab.Pane> },
    ];

    render() {
        return (
            <Tab panes={this.panes} />
        );
    }
}

export default SupplierDetailsContainer;